import { useState, useEffect } from "react";
import type { Word } from "@/types/word";

export const useWords = () => {
  const [words, setWords] = useState<Word[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    fetch("/data/words.json")
      .then((res) => res.json())
      .then((data) => setWords(data))
      .catch((err) => {
        console.error("Failed to load words:", err);
        setError(err);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return { words, isLoading, error };
};
